<app-page-wrapper scrollable="true">
  <div class="trusted-contacts-wrap">
    <app-heavy-header
      title="Trusted Contacts"
      description="You can invite up to 10 of your contacts that you trust to participate in the TailOne Network. They do not have to have meet the membership requirements.">
    </app-heavy-header>

    <p class="trusted-note">
      <span>Note:</span> If your trusted contact is reported for any abuse of the system, your TailOne account is subject to removal.
    </p>

    <div class="verification-pending-message" *ngIf="isSoftVerified">
      Your account is still being verified. You can add trusted contacts once you receive your verification email.
    </div>

    <ng-container *ngIf="!isSoftVerified">
      <div class="contacts-header">
        <div class="contacts-count">Trusted Contacts: {{ contactCount }}</div>
        <button class="add-contact-btn" type="button" [disabled]="!canAddContact" (click)="openTray()">
          Add Contact
        </button>
      </div>

      <app-alert-message *ngIf="listError" type="error" mb="16px" [canClose]="true" (onClose)="listError = null">
        {{ listError }}
      </app-alert-message>

      <div class="loading-row" *ngIf="isLoading">
        <app-spinner size="32px"></app-spinner>
      </div>

      <div class="empty-state" *ngIf="!isLoading && contacts.length === 0">
        Add your first trusted contact when you are ready.
      </div>

      <div class="contacts-list" *ngIf="!isLoading && contacts.length > 0">
        <div class="contact-row" *ngFor="let contact of contacts">
          <div class="contact-info">
            <div class="contact-name">{{ contact.name }}</div>
            <div class="contact-phone">{{ formatPhone(contact.phone) }}</div>
          </div>

          <div class="contact-actions">
            <button class="code-copy-btn" type="button" (click)="copyCode(contact)" [attr.aria-label]="'Copy code for ' + contact.name">
              <span class="code-copy-content">
                <span class="code-label">Invite Code</span>
                <span class="code">{{ contact.token }}</span>
              </span>
              <svg class="copy-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <rect x="9" y="9" width="10" height="10" rx="2"></rect>
                <path d="M5 15V7a2 2 0 0 1 2-2h8"></path>
              </svg>
              <span class="copied-label" *ngIf="copiedKey === contact.id">Copied</span>
            </button>

            <button
              *ngIf="!contact.used"
              class="delete-contact-btn"
              type="button"
              (click)="openDeleteTray(contact)"
              [attr.aria-label]="'Delete invite for ' + contact.name">
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M9 3h6l1 2h4v2H4V5h4l1-2Z"></path>
                <path d="M6 9h12l-.8 11.2A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.8L6 9Z"></path>
                <path d="M10 11v8M14 11v8"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <app-pop-tray
    *ngIf="showTray && !isSoftVerified"
    [header]="trayHeader"
    [description]="trayDescription"
    [actions]="trayActions">

    <form *ngIf="trayState === 'form'" class="contact-form" (ngSubmit)="submitContact(form)" #form="ngForm">
      <app-base-input
        id="contactName"
        name="contactName"
        placeholder="Name"
        [(ngModel)]="contactName"
        isFluid="true"
        mb="14px"
        required>
      </app-base-input>

      <app-phone-input
        [(ngModel)]="contactPhone"
        name="contactPhone"
        required="true"
        [isLight]="true"
        (e164Change)="onContactPhoneE164Change($event)">
      </app-phone-input>

      <app-primary-btn
        gradient="true"
        [disabled]="isSubmitting || !contactName.trim() || !isContactPhoneValid"
        [isLoading]="isSubmitting">
        Add Contact
      </app-primary-btn>
    </form>

    <div *ngIf="trayState === 'success' && createdContact" class="success-state">
      <div class="share-message">{{ createdContactMessage }}</div>

      <button class="copy-message-btn" type="button" (click)="copyCreatedMessage()">
        <svg class="copy-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect x="9" y="9" width="10" height="10" rx="2"></rect>
          <path d="M5 15V7a2 2 0 0 1 2-2h8"></path>
        </svg>
        {{ copiedKey === createdContact.id + '-message' ? 'Copied Message' : 'Copy Message' }}
      </button>

      <hr class="tray-divider">

      <div class="tray-button-row">
        <app-primary-btn *ngIf="canAddContact" gradient="true" (click)="addAnother()">Add Another</app-primary-btn>
        <app-secondary-btn (click)="closeTray()">Close</app-secondary-btn>
      </div>
    </div>

    <div *ngIf="trayState === 'error'" class="error-state">
      <app-alert-message type="error" mb="16px">
        {{ trayError }}
      </app-alert-message>
      <app-primary-btn gradient="true" (click)="tryAgain()">Try Again</app-primary-btn>
    </div>
  </app-pop-tray>

  <app-pop-tray
    *ngIf="contactToDelete && !isSoftVerified"
    header="Delete Trusted Contact?"
    [description]="deleteContactDescription"
    [actions]="deleteContactActions">
    <app-alert-message *ngIf="trayError" type="error" mb="16px">
      {{ trayError }}
    </app-alert-message>
  </app-pop-tray>
</app-page-wrapper>
